<template>
  <div class="page-member">
    <div class="title">{{$t('page.member.title')}}</div>
    <div style="display: table;margin:auto;">
      <!-- 手机号 -->
      <div style="display: table-row;">
        <span style="display: table-cell;"
              class="row-label">{{$t('page.member.mobile')}}</span>
        <span style="display: table-cell;text-align: left;"
              class="row-value">+{{user.state_code}}&nbsp;{{user.mobile}}</span>
        <span class="row-extra" style="display: table-cell;">
          <Button class="button" @click="pwd_modal_show=true">{{$t('page.member.btn_pwd')}}</Button>
        </span>
      </div>
      <!-- 昵称 -->
      <div style="display: table-row;">
        <span style="display: table-cell;"
              class="row-label">{{$t('page.member.nick')}}</span>
        <Input v-model="user.nick" maxlength="20"
               class="row-value"
               style="display: table-cell; border: none;"
               :placeholder="$t('page.member.ph_unset')"/>
        <span class="row-extra" style="display: table-cell;">&nbsp;</span>
      </div>
      <!-- 性别 -->
      <div style="display: table-row;">
        <span style="display: table-cell;"
              class="row-label">{{$t('page.member.sex')}}</span>
        <RadioGroup v-model="user.sex"
                    class="row-value"
                    style="display: table-cell;text-align: left;">
          <Radio :label="0">{{$t('page.member.sex_male')}}</Radio>
          &nbsp;&nbsp;
          <Radio :label="1">{{$t('page.member.sex_female')}}</Radio>
        </RadioGroup>
        <span class="row-extra" style="display: table-cell;">&nbsp;</span>
      </div>
      <!-- 生日 -->
      <div style="display: table-row;">
        <span style="display: table-cell;"
              class="row-label">{{$t('page.member.birth')}}</span>
        <Input v-model="user.birthday" readonly
               class="row-value"
               style="width: auto;display: table-cell;"
               :placeholder="$t('page.member.ph_unset')"/>
        <span class="row-extra" style="display: table-cell;">
          <Button class="button" @click="showBirthModal">{{$t('page.member.btn_birth')}}</Button>
        </span>
      </div>
      <!-- 地区 -->
      <div style="display: table-row;"><!-- v-if="user.areas"-->
        <span class="row-label" style="display: table-cell;">{{$t('page.member.location')}}</span>
        <Input v-model="mLocation" readonly
               class="row-value"
               style="display: table-cell;min-width: 200px;"
               :placeholder="$t('page.member.ph_unset')"/>
        <span class="row-extra" style="display: table-cell;">
          <Button @click="area_modal_show=true" class="button">{{$t('page.member.btn_location')}}</Button>
        </span>
      </div>
      <!-- sn -->
      <div style="display: table-row;">
        <span class="row-label" style="display: table-cell;">&nbsp;</span>
        <span class="row-value" style="display: table-cell;width: auto;">
          <Button @click="sn_show=!sn_show"
                  class="button">{{$tc('page.member.btn_sn_view', user.sns ? user.sns.length : 0)}}</Button>
        </span>
        <span class="row-extra" style="display: table-cell;">
          <Button class="button" @click="goBuySn">{{$t('page.member.btn_sn_buy')}}</Button>
        </span>
      </div>
    </div>
    <!-- 序号列表 -->
    <div v-if="sn_show" style="width:260px;max-width: 90%;margin:auto;">
      <List>
        <ListItem v-for="(sn,sn_i) in user.sns" :key="sn_i">
          <ListItemMeta :title="sn.sn" style="text-align: left;">
            <span v-if="sn.bind_time" slot="description">
              <!-- 已绑定 -->
              {{$t('page.member.label_device')+(sn.device||$t('page.member.no_device'))}}
              <br>
              {{$t('page.member.label_bind_time')+time2str(sn.bind_time)}}
              <span v-if="sn.expires_in">
                <br>{{$t('page.member.label_expires')+time2str(sn.expires_in)}}
              </span>
            </span>
            <span v-else>$t('page.member.label_no_bind')</span>
          </ListItemMeta>
        </ListItem>
      </List>
    </div>

    <div style="margin-bottom: 10px; margin-top:20vh;">
      <Button @click="modify" type="error"
              class="long-btn"
              style="margin-bottom: 10px;"
              :loading="saving">{{$t('page.member.btn_modify')}}</Button>
    </div>

    <!-- 生日选择 -->
    <Modal v-model="date_modal_show" :width="200" @on-ok="onBirthChanged">
      <p slot="header">{{$t('page.member.btn_birth')}}</p>
      <DatePicker v-model="date_value"
                  format="yyyy-MM-dd" type="date"
                  :placeholder="$t('page.member.ph_unset')"
                  style="width: 150px"></DatePicker>
    </Modal>

    <!-- 密码修改 -->
    <Modal v-model="pwd_modal_show" :width="300"
           :mask-closable="false" :title="$t('page.member.btn_pwd')">
      <div style="display: table;">
        <div style="display: table-row;">
          <span class="row-label" style="display: table-cell;">{{$t('page.member.old_pwd')}}</span>
          <Input v-model="oldpassword" maxlength="15" ref="old_pwd"
                 style="width: auto;display: table-cell;" type="password"
                 prefix="ios-key-outline"
                 :placeholder="$t('page.member.ph_old_pwd')"></Input>
        </div>
        <div style="display: table-row;">
          <span class="row-label" style="display: table-cell;">{{$t('page.member.new_pwd')}}</span>
          <Input v-model="password" maxlength="15" ref="pwd"
                 style="width: auto;display: table-cell;" type="password"
                 prefix="ios-key"
                 :placeholder="$t('page.member.ph_new_pwd')"></Input>
        </div>
        <div style="display: table-row;">
          <span class="row-label" style="display: table-cell;">{{$t('page.member.cfm_pwd')}}</span>
          <Input v-model="password1" maxlength="15"
                 style="width: auto;display: table-cell;" type="password"
                 prefix="ios-key"
                 :placeholder="$t('page.member.ph_cfm_pwd')"></Input>
        </div>
      </div>
      <div slot="footer">
        <Button @click="onPwdModify" type="primary">{{$t('common.btn_ok')}}</Button>
      </div>
    </Modal>
    <!-- 区域选择 -->
    <Modal v-model="area_modal_show" :width="300"
           :title="$t('page.member.btn_location')"
           footer-hide>
      <AreaSelect v-model="user.areas"
                  @on-change="(val)=>{mLocation=val}"
                  :header="$t('addr.ph_area_first')"/>
    </Modal>
  </div>
</template>

<script>
    import { ChangePwd } from '@/api/account';
    import AreaSelect from '@/components/AreaSelect';

    export default {
        components: {
            AreaSelect
        },
        data () {
            return {
                busy: false,
                saving: false,

                user: {},

                mLocation: '',
                area_modal_show: false,

                pwd_modal_show: false,
                oldpassword: '',
                password: '',
                password1: '',
                sn_show: false,

                date_modal_show: false,
                date_value: null
            }
        },
        methods: {
            time2str (unixstamp) {
                const d = new Date(unixstamp * 1000);
                let s = d.getFullYear();
                s += '-';
                const mm = d.getMonth() + 1;
                if (mm < 10) { s += '0'; }
                s += mm;
                s += '-';
                const dd = d.getDate();
                if (dd < 10) { s += '0'; }
                s += dd;
                return s;
            },
            goBuySn () {
                this.$router.face.goodsSearch('序號');
            },
            showBirthModal () {
                if (this.user.birthday) {
                    const dates = this.user.birthday.split('-');
                    if (dates.length === 0) {
                        return;
                    }
                    const y = parseInt(dates[0]);
                    if (isNaN(y) || y <= 1900) {
                        return;
                    }
                    const m = dates.length > 1 ? parseInt(dates[1]) : 0;
                    if (isNaN(m) || m <= 0 || m > 12) {
                        return;
                    }
                    const d = dates.length > 2 ? parseInt(dates[2]) : 0;
                    if (isNaN(d) || d <= 0 || d > 31) {
                        return;
                    }

                    if (!this.date_value) {
                        this.date_value = new Date();
                    }
                    this.date_value.setFullYear(y);
                    this.date_value.setMonth(m - 1);
                    this.date_value.setDate(d);
                } else {
                    this.date_value = null;
                }
                this.date_modal_show = true;
            },
            onBirthChanged () {
                if (this.date_value) {
                    const y = this.date_value.getFullYear();
                    const m = this.date_value.getMonth() + 1;
                    const d = this.date_value.getDate();
                    this.user.birthday = y + '-';
                    if (m < 10) {
                        this.user.birthday += '0';
                    }
                    this.user.birthday += m + '-';
                    if (d < 10) {
                        this.user.birthday += '0';
                    }
                    this.user.birthday += d;
                } else {
                    this.user.birthday = null;
                }
            },
            onPwdModify () {
                if (this.oldpassword.length < 6) {
                    this.$Message.error(this.$t('page.member.ph_old_pwd'));
                    this.$refs.old_pwd.focus();
                    return;
                }
                if (this.password.length < 6) {
                    this.$Message.error(this.$t('page.member.invalid_pwd'));
                    this.$refs.pwd.focus();
                    return;
                }
                if (this.password !== this.password1) {
                    this.$Message.error(this.$t('page.member.diff_pwd'));
                    this.$refs.pwd.focus();
                    return;
                }
                this.busy = true;
                this.$Spin.show();
                ChangePwd(this.oldpassword, this.password).then(res => {
                    this.pwd_modal_show = false;
                }).catch(() => {
                    this.$refs.old_pwd.focus();
                }).finally(() => {
                    this.$Spin.hide();
                    this.busy = false;
                });
            },
            modify () {
                let data = null;
                const user = this.$store.state.userinfo;
                if (user.nick !== this.user.nick) {
                    data = { nick: this.user.nick };
                }
                if (user.sex !== this.user.sex) {
                    if (!data) {
                        data = {};
                    }
                    data.sex = this.user.sex;
                }
                if (user.birthday !== this.user.birthday) {
                    if (!data) {
                        data = {};
                    }
                    data.birthday = this.user.birthday;
                }
                // 检查地区是否修改
                if (user.areas === null) {
                    user.areas = [];
                }
                if (this.user.areas === null) {
                    this.user.areas = [];
                }
                let areaChanged = user.areas.length !== this.user.areas.length;
                if (!areaChanged) {
                    for (let i = 0; i < user.areas.length; i++) {
                        if (user.areas[i] !== this.user.areas[i]) {
                            areaChanged = true;
                            break;
                        }
                    }
                }
                if (areaChanged) {
                    if (!data) {
                        data = {};
                    }
                    data.areas = user.areas;
                }

                if (!data) {
                    return;
                }
                this.busy = true;
                this.$Spin.show();
                this.saving = true;
                this.$store.dispatch('modifyUser', data).then((res) => {
                    this.user = { ...res };
                    this.$Message.success(this.$t('page.member.tip_modify_ok'));
                }).finally(() => {
                    this.saving = false;
                    this.$Spin.hide();
                    this.busy = false;
                });
            }
        },
        created () {
            this.user = { ...this.$store.state.userinfo };
            if (this.user.areas && this.user.areas.length > 0) {
                const onAreasReady = (areas) => {
                    const userAreas = this.user.areas;
                    let location = '';
                    for (const i in userAreas) {
                        const id = userAreas[i];
                        let found = false;
                        for (const j in areas) {
                            const item = areas[j];
                            if (item.id === id) {
                                if (location) {
                                    location += ' ';
                                }
                                location += item.label;
                                areas = item.children;
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            break;
                        }
                        if (!areas || areas.length === 0) {
                            areas = null;
                            break;
                        }
                    }
                    this.mLocation = location;
                };
                if (this.$store.state.areas) {
                    onAreasReady(this.$store.state.areas);
                } else {
                    this.mLocation = this.$t('page.member.loading_location');
                    this.$store.dispatch('loadAreas').then((res) => {
                        onAreasReady(res);
                    }).catch(() => {
                        this.mLocation = '';
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        },
        mounted () {
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    };
</script>

<style lang="scss">
  .page-member {
    text-align: center;

    .row-label {
      text-align: right;
      vertical-align: middle;
      font-weight: bold;
    }
    .row-value {
      padding-top: 10px;
      padding-bottom: 10px;
      width: auto;
    }
    .row-extra {
      padding-left: 5px;
      text-align: left;
      vertical-align: middle;
    }

    .ivu-input {
      border-radius: 0;
      border-left: none;
      border-right: none;
      border-top: none;
      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
    .ivu-radio-inner {
      border-color: #707070;
      &:after {
        background-color: #707070;
      }
    }
  }
</style>
